import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'

import App from './App.vue'
import router from './router'

// 从WordPress获取的nonce和REST API URL
const amjSettings = window.amjVueSettings || {
  restUrl: '/wp-json/amj/v1/',
  nonce: '',
  projectId: 0,
  projectTitle: '',
  mode: 'full',
  isFrontend: false,
  userId: 0,
  ajaxUrl: '/wp-admin/admin-ajax.php',
  strings: {},
  darkMode: false
}

// 从DOM元素获取项目ID（支持短代码方式）
const appElement = document.getElementById('amj-vue-app')
if (appElement) {
  const dataset = appElement.dataset
  if (dataset.projectId) {
    amjSettings.projectId = parseInt(dataset.projectId, 10)
  }
  if (dataset.mode) {
    amjSettings.mode = dataset.mode
  }
  if (dataset.frontend === 'true') {
    amjSettings.isFrontend = true
  }
  // 获取初始视图
  if (dataset.view) {
    amjSettings.initialView = dataset.view
  }
  // 获取深色模式设置 - DOM属性是字符串 '1' 或 '0'
  if (dataset.darkMode === '1') {
    amjSettings.darkMode = true
  }
}

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(router)

// 应用深色模式 - Element Plus 2.x 使用CSS变量
if (amjSettings.darkMode) {
  document.documentElement.classList.add('dark')
}

app.use(ElementPlus, {
  locale: zhCn,
  size: 'default',
  zIndex: 3000,
})

app.provide('amjSettings', amjSettings)

// 设置页面标题
if (amjSettings.projectTitle) {
  document.title = `${amjSettings.projectTitle} - AI漫剧生成器`
}

app.mount('#amj-vue-app')
